import { render, staticRenderFns } from "./movie_manage.vue?vue&type=template&id=7021b1c6"
import script from "./movie_manage.vue?vue&type=script&lang=js"
export * from "./movie_manage.vue?vue&type=script&lang=js"
import style0 from "./movie_manage.vue?vue&type=style&index=0&id=7021b1c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports